<template>
  <div class="content" ref="content">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar Notificación</b-breadcrumb-item>
    </b-breadcrumb>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary">OK</b-button>
    </b-modal>

    <b-modal
      id="confirmar-facturacion-modal"
      ref="confirmar-facturacion-modal"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-footer
      @close="() => confirmGenerarFactura(false)"
    >
      <h4 class="text-center">¿Desea facturar su pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="confirmGenerarFactura(false)">No en este momento</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="confirmGenerarFactura(true)">Sí</b-button>
    </b-modal>

    <b-modal
      id="datos-fiscales-modal"
      ref="datos-fiscales-modal"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      centered
      hide-footer
      hide-header
      @close.prevent
    >
      <FacturacionComponent
        :datosFacturacion="datosFacturacion"
        @closedFacturacionEvent="closedFacturacion($event)"
        @canceledFacturacionEvent="canceledFacturacion()"
      />
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-entrega-documentos" size="xl" centered hide-footer>
      <b-carousel id="carousel-notificaciones-2" :interval="0" indicators background="#ababab">
        <b-carousel-slide
          :img-src="require('@/assets/img/notificaciones/help/modal_2_notificaciones_entrega.webp')"
        ></b-carousel-slide>
      </b-carousel>
    </b-modal>

    <div class="container-fluid" v-if="!toShowExpediente">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeEditNotificaciones
              :notificacion="notificacion"
              :user="'Client'"
              @node="selected"
              :selectedComponent="currentComponentBody"
            />
          </b-card>
          <div>
            <b-img
              v-if="currentComponentBody === 'EnvioDomicilio'"
              :src="require('@/assets/img/notificaciones/help/5_envio_a_domicilio.webp')"
              fluid-grow
              alt="Descripción del envío a domicilio"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'ComplementaNotificado'"
              :src="require('@/assets/img/notificaciones/help/7_notificado.webp')"
              fluid-grow
              alt="Descripción del notificado"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'ComplementaSolicitantes'"
              :src="require('@/assets/img/notificaciones/help/8_solicitante_2_final.webp')"
              fluid-grow
              alt="Descripción de la información complementaria de los solicitantes"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'EntregaDocumentos'"
              :src="require('@/assets/img/notificaciones/help/6_entrega_docs_abre_modal_2.webp')"
              fluid-grow
              alt="Descripción de los documentos a subir"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'EntregaDocumentos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-entrega-documentos')"
            >
              Más información
            </b-button>
          </div>
        </b-col>
        <b-col class="col-9">
          <b-card>
            <b-row>
              <b-col class="col-12">
                <div v-if="currentComponentBody === 'Cotizacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(confirmaCotizacion)">
                      <Cotizacion
                        :notificacion="notificacion"
                        :isEditNotificacion="true"
                        :cotizacion="cotizacion"
                        :clausulasConfirmacion="clausulasConfirmacionCotizacion"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Pago'">
                  <Pago
                    :pagado="notificacion.pagado"
                    :forma_pago="notificacion.forma_pago"
                    :notificacion="notificacion"
                    @pay-cotizacion="payCotizacion($event)"
                    @pay-cotizacion-spei="payCotizacionSpei($event)"
                    @pay-cotizacion-monedero="payCotizacion($event)"
                  />
                </div>
                <div v-if="currentComponentBody === 'EnvioDomicilio'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(postDomicilioEnvio)" @change="getAddressInMapEnvio(null)">
                      <ComplementaDomicilio
                        :currentDomicilio="domicilioEnvio"
                        :notificacion="notificacion"
                        :clausulas-confirmacion="clausulasConfirmacionDomicilios"
                        @submit.prevent
                        @clausulaConfirmacionChanged="clausulaConfirmacionHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'ComplementaNotificado'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveComplementaNotificado)">
                      <ComplementaNotificado
                        :notificado="notificado"
                        :notificacion="notificacion"
                        :clausulas-confirmacion="clausulasConfirmacionNotificados"
                        @submit.prevent
                        @clausulaConfirmacionChanged="clausulaConfirmacionHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'ComplementaSolicitantes'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveComplementaSolicitantes)">
                      <ComplementaSolicitantes
                        :notificacion="notificacion"
                        @submit.prevent
                        :clausulas-confirmacion="clausulasConfirmacionSolicitantes"
                        @clausulaConfirmacionChanged="clausulaConfirmacionHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EntregaDocumentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveEntregaDocumentos)">
                      <EntregaDocumentos
                        :notificacion="notificacion"
                        @submit.prevent
                        :clausulas-confirmacion="clausulasConfirmacionDocumentos"
                        @clausulaConfirmacionChanged="clausulaConfirmacionHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EsperaValidacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveEntregaDocumentos)">
                      <EsperaValidacion :notificacion="notificacion" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'FirmaDocumentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveFirmaDocumentos)">
                      <FirmaDocumentos :notificacion="notificacion" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Cargando'">
                  <LoadingData></LoadingData>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div class="container-fluid" v-else>
      <b-card>
        <Expediente :notificacion="notificacion" />
      </b-card>
    </div>
  </div>
</template>

<script>
import EsperaValidacion from "@/components/EsperaValidacion.vue";
import ComplementaDomicilio from "../procesos/notificaciones/completaInfo/ComplementaDomicilio.vue";
import ComplementaNotificado from "@/views/clients/procesos/notificaciones/completaInfo/Notificado.vue";
import ComplementaSolicitantes from "@/views/clients/procesos/notificaciones/completaInfo/Solicitantes.vue";
import EntregaDocumentos from "@/views/clients/procesos/notificaciones/EntregaDocumentos.vue";
import FirmaDocumentos from "@/views/clients/procesos/notificaciones/FirmaDocumentos.vue";
import Pago from "@/views/clients/procesos/notificaciones/Pago.vue";
import TreeEditNotificaciones from "@/views/clients/procesos/notificaciones/TreeEditNotificaciones.vue";
import FacturacionComponent from "@/views/openpay/FacturacionComponent.vue";
import Expediente from "@/views/clients/procesos/notificaciones/Expediente.vue";
import LoadingData from "@/components/LoadingData.vue";
import Cotizacion from "src/views/clients/procesos/notificaciones/editInfo/CotizacionNotificacion.vue";

import {
  ComparecientesApi,
  CotizacionesApi,
  DomiciliosApi,
  FuncionesApi,
  NotificacionesApi,
  NotificadosApi,
  LayoutsApi,
  ClausulasConfirmacionApi,
} from "@/api";
import { getGoogleMapUrl } from "@/utils/google-maps-utils";
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "EditNotificaciones",

  components: {
    Cotizacion,
    Pago,
    TreeEditNotificaciones,
    ComplementaNotificado,
    ComplementaSolicitantes,
    EntregaDocumentos,
    FirmaDocumentos,
    FacturacionComponent,
    EsperaValidacion,
    Expediente,
    ComplementaDomicilio,
    LoadingData,
  },

  // props: {
  //   id: {
  //     type: [String, Number],
  //     default: null
  //   }
  // },

  created() {
    try {
      this.loading = true;

      const id = this.$route.params.id;

      this.getClausulasConfirmacion()
        .then(() => this.getNotificacion(id))
        .then(() => this.getNotificado(id))
        .then(() => this.getDomicilio(this.notificado.id_domicilios))
        .then(() => this.getDomicilioEnvio())
        .then(() => this.getCotizacion(this.notificacion.id_cotizaciones))
        .then(() => this.getEstatus())
        .catch(console.log);
    } catch (error) {
      this.$toast.error("Sucedió un error, intente más tarde", {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
      console.log(error);
    } finally {
      this.loading = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.includes("editcomparecientes")) {
      next();
      return;
    }

    this.$refs["modal-confirm-dialog-route"].show();
    this.next = next;
  },

  data: () => ({
    next: null,
    prenode: null,

    loading: false,
    currentComponentBody: "Cargando",

    clausulasConfirmacion: [],
    clausulasConfirmacionCotizacion: [],
    clausulasConfirmacionDomicilios: [],
    clausulasConfirmacionNotificados: [],
    clausulasConfirmacionSolicitantes: [],
    clausulasConfirmacionDocumentos: [],

    currentDomicilio: {
      tieneExtranjero: false,
      tieneTipo: false,
      compareciente: false,
      extranjero: null,
      notificaciones: true,
      lat: 19.4320605,
      lng: -99.1335938,
      disabled: false,
    },

    domicilioEnvio: {
      tieneExtranjero: false,
      tieneTipo: false,
      compareciente: false,
      extranjero: null,
      notificaciones: true,
      lat: 19.4320605,
      lng: -99.1335938,
      disabled: false,
    },

    notificacion: {
      id: null,
      id_estatus: null,
      id_cotizaciones: null,
      id_clientes: null,
      solicitantes: [],
      documentos: [],
      notificados: [],
      fad: null,
      acta_express_extra: null,
      envio: null,
      contenido_digital: null,
      corredurias_id: null,
      domicilios_id: null,
      hora_llegada: null,
      forma_cerciorarse: null,
      tipo_lugar: null,
      momento_clave_atendido: null,
      varios_lugares: null,
      otro_lugar: null,
      abierto_publico: null,
      ingreso_numeros_interiores: null,
      lugar_final_persona_atendio: null,
      persona_atendio_sexo: null,
      persona_atendio_edad: null,
      persona_atendio_estatura: null,
      persona_atendio_cabello: null,
      persona_atendio_complexion: null,
      momento_clave_persona_atendio: null,
      domicilio_señalado: null,
      domicilio_persona_buscada: null,
      declaracion_domicilio_negativo: null,
      recibio_comunicacion: null,
      instructivo_firmado: null,
      persona_atendio_nombre_proporcionado: null,
      persona_atendio_nombre: null,
      persona_atendio_identificacion: null,
      persona_atendio_identificacion_tipo_documento: null,
      persona_atendio_identificacion_numero: null,
      procedimiento_notificacion: null,
      hora_notificacion: null,
      persona_atendio_manifestaciones_realizadas: null,
      persona_atendio_manifestaciones: null,
      reporte_fotografico: null,
      validaEnvio: null,
      pagado: null,
      forma_pago: null,
      precio_total: 0,

      currentComponentValues: {
        Cotizacion: false,
        Ubicacion: false,
        Solicitantes: false,
        Documentos: false,
        Extras: false,
        Cotizacion: false,
        Pago: false,
        EnvioDomicilio: false,
        ComplementaNotificado: false,
        ComplementaSolicitantes: false,
        EntregaDocumentos: false,
        FirmaDocumentos: false,
        Diligencia: false,
        Actas: false,
        Expediente: false,
        Terminado: false,
        EsperaValidacion: false,
      },

      clausulas_confirmacion: [],
    },

    notificado: {
      id: null,
      nombre: null,
      paterno: null,
      materno: null,
      razon_social: null,
      persona: null,
      nombre_notificado: null,
      id_notificaciones: null,
      id_domicilios: null,
    },

    cotizacion: {},

    datos: {},
    datosCompletos: false,

    facturarPago: false,
    datosFacturacion: {
      cotizacionId: null,
      formaPago: null,
      alreadyInvoiced: false,
    },
  }),

  computed: {
    toShowExpediente() {
      return [11, 12, 13, 23, 58].includes(this.notificacion.id_estatus);
    },

    // clausulasDomicilio() {
    //   const clausulas = this.notificacion.clausulas_confirmacion.filter(c => [7].includes(c.id));

    //   if (clausulas.length > 0) {
    //     return clausulas;
    //   }

    //   return this.clausulasConfirmacion.filter(c => [7].includes(c.id)).map(c => ({
    //     ...c,
    //     confirmado: false
    //   }));
    // },
    // clausulasNotificado() {
    //   const clausulas = this.notificacion.clausulas_confirmacion.filter(c => [8].includes(c.id));

    //   if (clausulas.length > 0) {
    //     return clausulas;
    //   }

    //   return this.clausulasConfirmacion.filter(c => [8].includes(c.id)).map(c => ({
    //     ...c,
    //     confirmado: false
    //   }));
    // },
    // clausulasSolicitante() {
    //   const clausulas = this.notificacion.clausulas_confirmacion.filter(c => [9].includes(c.id));

    //   if (clausulas.length > 0) {
    //     return clausulas;
    //   }

    //   return this.clausulasConfirmacion.filter(c => [9].includes(c.id)).map(c => ({
    //     ...c,
    //     confirmado: false
    //   }));
    // },
    // clausulasDocumentos() {
    //   const clausulas = this.notificacion.clausulas_confirmacion.filter(c => [10].includes(c.id));

    //   if (clausulas.length > 0) {
    //     return clausulas;
    //   }

    //   return this.clausulasConfirmacion.filter(c => [10].includes(c.id)).map(c => ({
    //     ...c,
    //     confirmado: false
    //   }));
    // }
  },

  methods: {
    beforeLeave(answer) {
      if (answer) {
        this.next();
      }
    },

    selected(node) {
      if (this.notificacion.pagado && ["Pago", "Cotizacion"].includes(node)) {
        return;
      }

      const keys = Object.keys(this.notificacion.currentComponentValues);
      const values = Object.values(this.notificacion.currentComponentValues);
      const dest = keys.find((value) => value == node);
      const pagoIndex = keys.findIndex((value) => value === "Cotizacion");
      const currentIndex = keys.findIndex((value) => value == this.currentComponentBody);
      const destIndex = keys.findIndex((value) => value == node);
      const lastCompletedIndex = values.lastIndexOf(true);

      // Ir mas adelante
      if (destIndex > currentIndex) {
        // Dest verde
        if (this.notificacion.currentComponentValues[dest]) {
          this.currentComponentBody = dest;
        }
        // Dest amarillo
        else {

          let lastCompleted = keys[lastCompletedIndex + 1];
          if (destIndex - lastCompletedIndex === 1) {
            this.currentComponentBody = dest;
          } else {
            if (lastCompletedIndex === -1) {
              lastCompleted = keys[0];
            }
            // this.$toast.warning("Completa la sección " + lastCompleted + " para poder continuar", {
            this.$toast.warning("Completa la sección para poder continuar", {
              timeout: 3000, //false,
              hideProgressBar: false,
              position: "top-right",
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              closeButton: "button",
              icon: true,
            });
          }
        }
      }
      // Ir mas atras
      else {
        if (destIndex >= pagoIndex) {
          this.currentComponentBody = dest;
        }
      }
    },

    clausulaConfirmacionHandler(clausulaId, value) {
      const clausulaConfirmacionExistente = this.notificacion.clausulas_confirmacion.find(
        (c) => c.clausula_confirmacion_id === clausulaId,
      );

      if (clausulaConfirmacionExistente) {
        clausulaConfirmacionExistente.confirmado = value;
      } else {
        this.notificacion.clausulas_confirmacion.push({
          clausula_confirmacion_id: clausulaId,
          cat_servicio_id: 2,
          confirmado: value,
        });
      }
    },

    async getClausulasConfirmacion() {
      const { value } = await ClausulasConfirmacionApi.list({
        page: 0,
        registersPerPage: 0,
        catServicioId: 2,
      });

      this.clausulasConfirmacion = value;
    },

    async getAddressInMap(direcciones_id) {
      if (direcciones_id === null) {
        const address = `${this.currentDomicilio.calle},${this.currentDomicilio.num_exterior},${this.currentDomicilio.colonia}
            ,${this.currentDomicilio.delegacion_municipio},${this.currentDomicilio.codigo_postal},${this.currentDomicilio.ciudad}
            ,${this.currentDomicilio.entidad}`;
        const mapUrl = await getGoogleMapUrl(address);

        if (mapUrl === null) {
          return;
        }

        this.currentDomicilio.lat = mapUrl.lat.toString(); //parseFloat(mapUrl.lat);
        this.currentDomicilio.lng = mapUrl.lng.toString(); //parseFloat(mapUrl.lng);
        const a = structuredClone(this.currentDomicilio);

        this.currentDomicilio = a;
      }
    },

    async getAddressInMapEnvio(direcciones_id) {
      if (direcciones_id === null) {
        const address = `${this.domicilioEnvio.calle},${this.domicilioEnvio.num_exterior},${this.domicilioEnvio.colonia}
          ,${this.domicilioEnvio.delegacion_municipio},${this.domicilioEnvio.codigo_postal},${this.domicilioEnvio.ciudad}
          ,${this.domicilioEnvio.entidad}`;

        const mapUrl = await getGoogleMapUrl(address);

        if (!mapUrl) {
          return;
        }

        this.domicilioEnvio.lat = mapUrl.lat.toString(); //parseFloat(mapUrl.lat);
        this.domicilioEnvio.lng = mapUrl.lng.toString(); //parseFloat(mapUrl.lng);

        const a = structuredClone(this.domicilioEnvio);

        this.domicilioEnvio = a;
      }
    },

    async getNotificacion(id) {
      this.notificacion = {
        ...this.notificacion,
        ...(await NotificacionesApi.detail(id)),
      };

      const ccc = this.notificacion.clausulas_confirmacion.filter((c) => [2, 3, 4, 5, 6].includes(c.clausula_confirmacion_id));

      if (this.notificacion.fad) {
        ccc.splice(1, 1);
      }

      if (ccc.length > 0) {
        ccc.forEach((c) => {
          c.contenido = this.clausulasConfirmacion.find((cc) => cc.id === c.clausula_confirmacion_id).contenido;
        });
        this.clausulasConfirmacionCotizacion = ccc;
        if (ccc.every((c) => c.confirmado)) {
          this.notificacion.currentComponentValues.Cotizacion = true;
          // this.domicilioEnvio.disabled = true;
          // this.currentComponentBody = 'ComplementaNotificado';
        }
      } else {
        this.clausulasConfirmacionCotizacion = this.clausulasConfirmacion
          .filter((c) => [2, 3, 4, 5, 6].includes(c.id))
          .map((c) => ({
            ...c,
            confirmado: false,
          }));
      }

      const ccd = this.notificacion.clausulas_confirmacion.filter((c) => [7].includes(c.clausula_confirmacion_id));
      if (ccd.length > 0) {
        ccd.forEach((c) => {
          c.contenido = this.clausulasConfirmacion.find((cc) => cc.id === c.clausula_confirmacion_id).contenido;
        });
        this.clausulasConfirmacionDomicilios = ccd;
        if (ccd.every((c) => c.confirmado)) {
          this.notificacion.currentComponentValues.EnvioDomicilio = true;
          this.domicilioEnvio.disabled = true;
          // this.currentComponentBody = 'ComplementaNotificado';
        }
      } else {
        this.clausulasConfirmacionDomicilios = this.clausulasConfirmacion
          .filter((c) => [7].includes(c.id))
          .map((c) => ({
            ...c,
            confirmado: false,
          }));
      }

      const ccn = this.notificacion.clausulas_confirmacion.filter((c) => [8].includes(c.clausula_confirmacion_id));
      if (ccn.length > 0) {
        ccn.forEach((c) => {
          c.contenido = this.clausulasConfirmacion.find((cc) => cc.id === c.clausula_confirmacion_id).contenido;
        });
        this.clausulasConfirmacionNotificados = ccn;
        if (ccn.every((c) => c.confirmado)) {
          this.notificacion.currentComponentValues.ComplementaNotificado = true;
          // this.currentComponentBody = 'ComplementaSolicitantes';
        }
      } else {
        this.clausulasConfirmacionNotificados = this.clausulasConfirmacion
          .filter((c) => [8].includes(c.id))
          .map((c) => ({
            ...c,
            clausula_confirmacion_id: c.id,
            confirmado: false,
          }));
      }

      const ccs = this.notificacion.clausulas_confirmacion.filter((c) => [9].includes(c.clausula_confirmacion_id));
      if (ccs.length > 0) {
        ccs.forEach((c) => {
          c.contenido = this.clausulasConfirmacion.find((cc) => cc.id === c.clausula_confirmacion_id).contenido;
        });
        this.clausulasConfirmacionSolicitantes = ccs;
        if (ccs.every((c) => c.confirmado)) {
          this.notificacion.currentComponentValues.ComplementaSolicitantes = true;
          // this.currentComponentBody = 'EntregaDocumentos';
        }
      } else {
        this.clausulasConfirmacionSolicitantes = this.clausulasConfirmacion
          .filter((c) => [9].includes(c.id))
          .map((c) => ({
            ...c,
            confirmado: false,
          }));
      }

      const ccdocs = this.notificacion.clausulas_confirmacion.filter((c) => [10].includes(c.clausula_confirmacion_id));
      if (ccdocs.length > 0) {
        ccdocs.forEach((c) => {
          c.contenido = this.clausulasConfirmacion.find((cc) => cc.id === c.clausula_confirmacion_id).contenido;
        });
        this.clausulasConfirmacionDocumentos = ccdocs;
        if (ccdocs.every((c) => c.confirmado)) {
          this.notificacion.currentComponentValues.EntregaDocumentos = true;
          // this.currentComponentBody = 'ComplementaDocumentos';
        }
      } else {
        this.clausulasConfirmacionDocumentos = this.clausulasConfirmacion
          .filter((c) => [10].includes(c.id))
          .map((c) => ({
            ...c,
            confirmado: false,
          }));
      }
    },

    async getNotificado(id) {
      const { value } = await NotificadosApi.list({ id_notificaciones: id });

      this.notificado.id = value[0].id;
      this.notificado.nombre = value[0].nombre;
      this.notificado.paterno = value[0].paterno;
      this.notificado.materno = value[0].materno;
      this.notificado.razon_social = value[0].razon_social;
      this.notificado.persona = value[0].persona;
      this.notificado.nombre_notificado = value[0].nombre_notificado;
      this.notificado.id_domicilios = value[0].id_domicilios;
      this.notificado.id_notificaciones = value[0].id_notificaciones;

      if (this.notificado.nombre || this.notificado.razon_social) {
        this.notificacion.notificados = value;
      }
    },

    async getDomicilio(id_domicilios) {
      const { calle, num_exterior, num_interior, colonia, delegacion_municipio, ciudad, entidad, pais, codigo_postal, lat, lng } =
        await DomiciliosApi.detail(id_domicilios);

      this.currentDomicilio.calle = calle;
      this.currentDomicilio.num_exterior = num_exterior;
      this.currentDomicilio.num_interior = num_interior;
      this.currentDomicilio.colonia = colonia;
      this.currentDomicilio.delegacion_municipio = delegacion_municipio;
      this.currentDomicilio.ciudad = ciudad;
      this.currentDomicilio.entidad = entidad;
      this.currentDomicilio.pais = pais;
      this.currentDomicilio.codigo_postal = codigo_postal;
      this.currentDomicilio.lat = lat;
      this.currentDomicilio.lng = lng;
    },

    async getDomicilioEnvio() {
      this.domicilioEnvio = {
        ...this.domicilioEnvio,
        ...(await DomiciliosApi.detail(this.notificacion.domicilios_id)),
      };
    },

    async getCotizacion(id_cotizacion) {
      const cotizacion = await CotizacionesApi.detail(id_cotizacion);

      this.notificacion.precio_total = cotizacion.precio_total;
      this.notificacion.pagado = cotizacion.pagado;
      this.notificacion.forma_pago = cotizacion.forma_pago;
      this.cotizacion = cotizacion;
    },

    getEstatus() {
      if (this.notificacion.id_estatus == 7) {
        this.currentComponentBody = "Pago";

        const keys = Object.keys(this.notificacion.currentComponentValues);
        const currentIndex = keys.findIndex((value) => value === "Pago");

        for (let i = 0; i < currentIndex; i++) {
          this.notificacion.currentComponentValues[keys[i]] = true;
        }

        return;
      }

      const keys = Object.keys(this.notificacion.currentComponentValues);
      let currentIndex = keys.findIndex((value) => value === "Pago");

      if ([11, 12, 23, 58].includes(this.notificacion.id_estatus)) {
        this.notificado.aceptado = true;
        this.currentComponentBody = "EsperaValidacion";
        currentIndex = keys.findIndex((value) => value === "FirmaDocumentos");
      } else {
        if (this.notificacion.id_estatus == 8 && this.notificacion.envio == 1) {
          this.currentComponentBody = "EnvioDomicilio";
          currentIndex = keys.findIndex((value) => value === "EnvioDomicilio");
        }
        if (this.notificacion.id_estatus == 8 && this.notificacion.envio == 0) {
          this.domicilioEnvio.disabled = true;
          this.currentComponentBody = "ComplementaNotificado";
          currentIndex = keys.findIndex((value) => value === "ComplementaNotificado");
        }
        if (this.notificacion.id_estatus == 8 && (this.notificado.nombre || this.notificado.razon_social)) {
          this.notificado.aceptado = true;
          this.currentComponentBody = "ComplementaSolicitantes";
          currentIndex = keys.findIndex((value) => value === "ComplementaSolicitantes");
        }
        if (
          this.notificacion.id_estatus == 22 &&
          !this.notificacion.validaSolicitantes &&
          !this.notificacion.validaDomicilio &&
          !this.notificacion.validaNotificado &&
          !this.notificacion.validaDocumentos &&
          !this.notificacion.validaExtras &&
          !this.notificacion.validaEnvio
        ) {
          this.notificado.aceptado = true;
          this.currentComponentBody = "EntregaDocumentos";
          currentIndex = keys.findIndex((value) => value === "EntregaDocumentos");
        }
        if (
          (this.notificacion.id_estatus == 22 &&
            (this.notificacion.validaSolicitantes ||
              this.notificacion.validaDomicilio ||
              this.notificacion.validaNotificado ||
              this.notificacion.validaDocumentos ||
              this.notificacion.validaExtras ||
              this.notificacion.validaEnvio)) ||
          this.notificacion.id_estatus == 10
        ) {
          this.notificado.aceptado = true;
          this.currentComponentBody = "EsperaValidacion";
          currentIndex = keys.findIndex((value) => value === "FirmaDocumentos");
        }
        if (this.notificacion.id_estatus == 13) {
          this.currentComponentBody = "Terminado";
          // currentIndex = keys.findIndex(value => value === 'FirmaDocumentos')
        }
      }

      for (let i = 0; i < currentIndex; i++) {
        this.notificacion.currentComponentValues[keys[i]] = true;
      }
    },

    async confirmaCotizacion() {
      try {
        this.loading = true;

        // const p1 = NotificacionesApi.update(this.notificacion.id, {
        //   acta_express_extra: this.notificacion.acta_express ? 1 : 0,
        //   envio: this.notificacion.envio_domicilio ? 1 : 0,
        // });
        // const p2 = CotizacionesApi.edit(this.cotizacion.id, this.cotizacion);
        // const promises = [p1, p2];

        // await Promise.all(promises);

        this.notificacion.currentComponentValues.Cotizacion = true;
        this.currentComponentBody = "Pago";
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    payCotizacion(payed) {
      if (payed == true) {
        this.generaPago();
      }
    },

    payCotizacionSpei(payed) {
      if (payed) {
        this.$toast.warning("Recibirá la información para la transferencia en su correo electrónico.", {
          timeout: 10000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } else {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }

      this.loading = false;
    },

    async generaPago(isMonedero = false) {
      try {
        // Cambia el estatus de la notificacion a pagado
        this.loading = true;

        const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
          id_estatus: 8,
          id_cotizaciones: this.notificacion.id_cotizaciones,
          id_clientes: this.notificacion.id_clientes,
          fad: this.notificacion.fad,
          acta_express_extra: this.notificacion.acta_express_extra,
          envio: this.notificacion.envio,
          validaSolicitantes: 0,
          validaDomicilio: 0,
          validaNotificado: 0,
          validaDocumentos: 0,
          validaExtras: 0,
          activo: 1,
          contenido_digital: this.notificacion.contenido_digital,
          validaEnvio: this.notificacion.validaEnvio,
          domicilios_id: this.notificacion.domicilios_id,
          corredurias_id: this.notificacion.corredurias_id,
          clausulas_confirmacion: this.notificacion.clausulas_confirmacion,
          currentForm: this.currentComponentBody,
        });

        this.notificacion.id_estatus = id_estatus;
        this.notificacion.currentComponentValues.Pago = true;
        this.loading = false;

        if (!isMonedero) {
          this.$refs["confirmar-facturacion-modal"].show();

          return;
        }

        if (this.notificacion.envio == 1) {
          this.currentComponentBody = "EnvioDomicilio";
        } else {
          this.currentComponentBody = "ComplementaNotificado";
        }
      } catch (error) {
        this.loading = false;
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        console.log(error);
      }
    },

    confirmGenerarFactura(crearFactura) {
      this.$refs["confirmar-facturacion-modal"].hide();

      if (!crearFactura) {
        if (this.notificacion.envio == 1) {
          this.currentComponentBody = "EnvioDomicilio";
        } else {
          this.currentComponentBody = "ComplementaNotificado";
        }

        return;
      }

      this.datosFacturacion.cotizacionId = this.notificacion.id_cotizaciones;
      this.datosFacturacion.alreadyInvoiced = false;

      this.$refs["datos-fiscales-modal"].show();
    },

    async postDomicilioEnvio() {
      try {
        this.loading = true;

        this.clausulasConfirmacionDomicilios.forEach((c) => {
          this.clausulaConfirmacionHandler(c.id, c.confirmado);
        });

        const { id } = await DomiciliosApi.create({
          calle: this.domicilioEnvio.calle,
          num_exterior: this.domicilioEnvio.num_exterior,
          num_interior: this.domicilioEnvio.num_interior,
          colonia: this.domicilioEnvio.colonia,
          delegacion_municipio: this.domicilioEnvio.delegacion_municipio,
          ciudad: this.domicilioEnvio.ciudad,
          entidad: this.domicilioEnvio.entidad,
          pais: this.domicilioEnvio.pais,
          codigo_postal: this.domicilioEnvio.codigo_postal,
          extranjero: 0,
          tipo: "Personal",
          tieneExtranjero: null,
          tieneTipo: null,
          lat: this.domicilioEnvio.lat,
          lng: this.domicilioEnvio.lng,
          valido: 1,
          comentario: null,
          validador: null,
          activo: 1,
        });
        this.notificacion.domicilios_id = id;
        const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
          id_estatus: 8,
          id_cotizaciones: this.notificacion.id_cotizaciones,
          id_clientes: this.notificacion.id_clientes,
          fad: this.notificacion.fad,
          acta_express_extra: this.notificacion.acta_express_extra,
          envio: this.notificacion.envio,
          validaSolicitantes: 0,
          validaDomicilio: 0,
          validaNotificado: 0,
          validaDocumentos: 0,
          validaExtras: 0,
          validaEnvio: this.notificacion.validaEnvio,
          activo: 1,
          contenido_digital: this.notificacion.contenido_digital,
          domicilios_id: this.notificacion.domicilios_id,
          corredurias_id: this.notificacion.corredurias_id,
          clausulas_confirmacion: this.notificacion.clausulas_confirmacion,
          currentForm: this.currentComponentBody,
        });

        this.domicilioEnvio.disabled = true;
        this.notificacion.currentComponentValues.EnvioDomicilio = true;
        this.currentComponentBody = "ComplementaNotificado";
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async saveComplementaNotificado() {
      if (this.notificacion.notificados.length == 0) {
        this.$toast.warning("Debe ingresar al menos 1 notificado.", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return;
      }

      try {
        this.loading = true;

        this.clausulasConfirmacionNotificados.forEach((c) => {
          this.clausulaConfirmacionHandler(c.id, c.confirmado);
        });

        // Agrega los datos del notificado a BD
        await NotificadosApi.edit(this.notificado.id, {
          nombre: this.notificacion.notificados[0].nombre,
          paterno: this.notificacion.notificados[0].paterno,
          materno: this.notificacion.notificados[0].materno,
          razon_social: this.notificacion.notificados[0].razon_social,
          persona: this.notificacion.notificados[0].persona,
          nombre_notificado: this.notificacion.notificados[0].nombre_notificado,
          id_notificaciones: this.notificado.id_notificaciones,
          id_domicilios: this.notificado.id_domicilios,
          activo: 1,
        });

        if (this.notificacion.notificados.length > 1) {
          this.createNewNotificados();
        }

        const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
          ...this.notificacion,
          activo: 1,
          currentForm: this.currentComponentBody,
        });

        this.notificacion.currentComponentValues.ComplementaNotificado = true;
        this.currentComponentBody = "ComplementaSolicitantes";
        this.loading = false;
        this.notificacion.aceptado = true;
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async createNewNotificados() {
      for (let i = 1; i < this.notificacion.notificados.length; i++) {
        const { id } = await NotificadosApi.create({
          id_notificaciones: this.notificado.id_notificaciones,
        });
        this.editNewNotificado(id, i);
      }
    },

    async editNewNotificado(id, i) {
      await NotificadosApi.edit(id, {
        nombre: this.notificacion.notificados[i].nombre,
        paterno: this.notificacion.notificados[i].paterno,
        materno: this.notificacion.notificados[i].materno,
        razon_social: this.notificacion.notificados[i].razon_social,
        persona: this.notificacion.notificados[i].persona,
        nombre_notificado: this.notificacion.notificados[i].nombre_notificado,
        id_notificaciones: this.notificado.id_notificaciones,
        id_domicilios: this.notificado.id_domicilios,
        activo: 1,
      });
    },

    async actualizaCompareciente(compareciente) {
      try {
        const comparecienteToUpdate = {
          nombre: compareciente.nombre,
          paterno: compareciente.paterno,
          fecha_nacimiento: compareciente.fecha_nacimiento,
          curp: compareciente.curp,
          rfc: compareciente.rfc,
          ocupacion: compareciente.ocupacion,
          lugar_nacim_ciudad: compareciente.lugar_nacim_ciudad,
          lugar_nacim_estado: compareciente.lugar_nacim_estado,
          lugar_nacim_pais: compareciente.lugar_nacim_pais,
          denominacion_social: compareciente.denominacion_social,
          fecha_constitucion: compareciente.fecha_constitucion,
          tipo_validacion: compareciente.tipo_validacion,
          cliente_id: compareciente.cliente_id,
          persona: compareciente.persona,
          telefonos: compareciente.telefonos,
          email: compareciente.email,
          activo: 1,
        };

        await ComparecientesApi.edit(compareciente.id, comparecienteToUpdate);

        const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
          ...this.notificacion,
          activo: 1,
          currentForm: this.currentComponentBody,
        });
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        console.log(error);
      }
    },

    async saveComplementaSolicitantes() {
      this.loading = true;

      if (this.clausulasConfirmacionSolicitantes.some((c) => !c.confirmado)) {
        this.$toast.warning("Debe aceptar las cláusulas para continuar.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
        return;
      }

      this.clausulasConfirmacionSolicitantes.forEach((c) => {
        this.clausulaConfirmacionHandler(c.id, c.confirmado);
      });

      if (this.notificacion.solicitantes.some((s) => !s.completo)) {
        this.$toast.warning("Debe completar la información necesaria para continuar.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
        return;
      }

      // return;

      // Busca los solicitantes que hay que modificar
      // const solicitantesModificados = [];

      // this.notificacion.solicitantes.forEach(solicitante => {
      //   if (solicitante.editado) {
      //     solicitantesModificados.push(solicitante);
      //   }
      // });

      // Modifica los solicitantes encontrados
      // for (const solicitanteModificado of solicitantesModificados) {
      //   await this.actualizaCompareciente(solicitanteModificado);
      // };

      // Cambia el estatus de la notificacion a Informacion Completada
      const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
        id_estatus: 22,
        id_cotizaciones: this.notificacion.id_cotizaciones,
        id_clientes: this.notificacion.id_clientes,
        fad: this.notificacion.fad,
        acta_express_extra: this.notificacion.acta_express_extra,
        envio: this.notificacion.envio,
        validaSolicitantes: 0,
        validaDomicilio: 0,
        validaNotificado: 0,
        validaDocumentos: 0,
        validaExtras: 0,
        activo: 1,
        contenido_digital: this.notificacion.contenido_digital,
        validaEnvio: this.notificacion.validaEnvio,
        domicilios_id: this.notificacion.domicilios_id,
        corredurias_id: this.notificacion.corredurias_id,
        clausulas_confirmacion: this.notificacion.clausulas_confirmacion,
        currentForm: this.currentComponentBody,
      });

      this.notificacion.id_estatus = id_estatus;
      this.notificacion.currentComponentValues.ComplementaSolicitantes = true;
      this.currentComponentBody = "EntregaDocumentos";
      this.loading = false;
    },

    async saveEntregaDocumentos() {
      try {
        this.loading = true;

        if (!this.validaDocumentosCompletos()) {
          this.loading = false;
          return;
        }

        // if (this.notificacion.documentos.some(d => !d.documento)) {
        //   this.$toast.warning("Favor de subir los documentos faltantes para poder continuar.", {
        //     timeout: 4000,
        //     hideProgressBar: false,
        //     position: "top-right",
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: false,
        //     closeButton: "button",
        //     icon: true,
        //   });
        //   this.loading = false;
        //   return;
        // }

        this.clausulasConfirmacionDocumentos.forEach((c) => {
          this.clausulaConfirmacionHandler(c.id, c.confirmado);
        });

        const { id_estatus } = await NotificacionesApi.edit(this.notificacion.id, {
          id_estatus: 10,
          id_cotizaciones: this.notificacion.id_cotizaciones,
          id_clientes: this.notificacion.id_clientes,
          fad: this.notificacion.fad,
          acta_express_extra: this.notificacion.acta_express_extra,
          envio: this.notificacion.envio,
          validaSolicitantes: 0,
          validaDomicilio: 0,
          validaNotificado: 0,
          validaDocumentos: 0,
          validaExtras: 0,
          activo: 1,
          contenido_digital: this.notificacion.contenido_digital,
          validaEnvio: this.notificacion.validaEnvio,
          domicilios_id: this.notificacion.domicilios_id,
          corredurias_id: this.notificacion.corredurias_id,
          clausulas_confirmacion: this.notificacion.clausulas_confirmacion,
          currentForm: this.currentComponentBody,
        });

        this.notificacion.id_estatus = id_estatus;
        this.notificacion.currentComponentValues.EntregaDocumentos = true;
        this.notificacion.currentComponentValues.EsperaValidacion = true;
        this.currentComponentBody = "EsperaValidacion";

        this.$toast.success(
          "Los documentos fueron entregados correctamente y serán revisados por un corredor. Posteriormente recibirá un mail con las instrucciones para la Firma Digital de sus documentos.",
          {
            timeout: 40000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          },
        );
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    validaDocumentosCompletos() {
      let documentosCompletos = true;

      const esCliente = storage.getItem("role").includes("Cliente");

      for (const documento of this.notificacion.documentos) {
        if (!documento.documento) {
          if (esCliente) {
            if (documento.cat_documentos_id == 67) continue;
          }

          documentosCompletos = false;
          break;
        }
      }

      if (!documentosCompletos) {
        this.$toast.warning("Favor de subir los documentos faltantes para poder continuar.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      }

      return documentosCompletos;
    },

    closedFacturacion(event) {
      // this.facturarPago = true;

      if (this.notificacion.envio == 1) {
        this.currentComponentBody = "EnvioDomicilio";
      } else {
        this.currentComponentBody = "ComplementaNotificado";
      }

      this.$refs["datos-fiscales-modal"].hide();
    },

    canceledFacturacion() {
      if (this.notificacion.envio == 1) {
        this.currentComponentBody = "EnvioDomicilio";
      } else {
        this.currentComponentBody = "ComplementaNotificado";
      }

      this.$refs["datos-fiscales-modal"].hide();
    },
  },
};
</script>
